import {
  ApiDeleteRequest,
  ApiGetRequest,
  // ApiPostMultipart,
  ApiPostRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Upgrade Repair',
    title_repair: 'Repair Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Upgrade Repair',
        href: '/opc/eor/repeat-repair',
        active: true,
      },
    ],
    items: [],
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_eor_repeat_detail',
    sortDesc: true,
    fields: [
      {
        key: 'date_repeat',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
      },
      {
        key: 'code_eor',
        label: 'EOR',
        sortable: false,
      },
      {
        key: 'status_repeat',
        label: 'Status',
        sortable: false,
      },
      {
        key: 'aksi',
      },
    ],
    form: {
      id_principle: '',
      code_principle: '',
      principle: '',
      id_vendor_repair: '',
      code_vendor: '',
      vendor_name: '',
      containers: [],
      doc_no: '',
    },
    list_doc: [],
    repair_type: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeRepeatRepair(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetFormRepeatRepair(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        id_principle: '',
        items: [],
        doc_no: '',
        ex_vessel: '',
        voy: '',
        consignee: '',
        principle: '',
      },
      search: '',
    });
  },
};

export const actions = {
  async searchDocument({ commit }, payload = null) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/repeat-repair/document`, payload);
    commit('changeRepeatRepair', {
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getListContEOR({ commit, state }) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      principle: data.form.id_principle || '',
      q: data.search,
    };

    let result = await ApiGetRequest(`opr/repeat-repair/search`, params);
    commit('changeRepeatRepair', {
      loading: false,
    });

    if (!result.error) {
      commit('changeRepeatRepair', {
        form: {
          ...data.form,
          containers: result.data.object || [],
        },
      });
    }

    return !result.error ? true : false;
  },

  async getListRepeatRepair({ commit, state }) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      status_repair: data.status_repair ? data.status_repair : '',
      id_principle: data.id_principle ? data.id_principle : '',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`opr/repeat-repair`, params);
    commit('changeRepeatRepair', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailRepeatRepair({ commit }, payload = null) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/repeat-repair/${payload.id}`);
    commit('changeRepeatRepair', {
      loading: false,
    });

    if (!result.error) {
      commit('changeRepeatRepair', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createRepeatRepair({ commit, state, dispatch }) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/repeat-repair`, data.form);
    commit('changeRepeatRepair', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateRepeatRepair({ commit, state, dispatch }, payload = null) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/repeat-repair/${payload.id}`,
      data.form
    );
    commit('changeRepeatRepair', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteRepeatRepair({ commit, dispatch }, payload = null) {
    commit('changeRepeatRepair', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/repeat-repair/${payload.id}`);
    commit('changeRepeatRepair', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
